export default [
  { id: '', name: 'за замовчуванням' },
  { id: '-price', name: 'від дорогих до дешевих' },
  { id: 'price', name: 'від дешевих до дорогих' },
  { id: '-created_at', name: 'за датою подачі' }
];
